import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Select, message, Spin, } from 'antd';
import WebLinks from '../../api/WebLinks';
import constants from '../../constants/constants';
import APIUtils from '../../api/APIUtils';
import Cookies from 'js-cookie';
import { CommonContext } from '../../Context';

const { Option } = Select
const ChatBotJob = (props) => {

  const [jobs,setJobs]=useState([]);
  const [loading,setLoading]=useState(false);
  const [jobId,setJobId]=useState("");
  const [jobExists,setJobExists]=useState(props?.jobExists);
  const [countrycode,setCountryCode]=useState(props?.countrycode);
  const commonContext=useContext(CommonContext);
  const [buyerID,setBuyerId]=useState(props?.jobExists===true?commonContext.common.buyerId:1298)

  useEffect(() => {
    let buyerId=buyerID;
    let bottype;
    if(props?.jobExists===true){
      bottype="apply-"+jobId; 
    }else{
      bottype="apply-"+1298; 
    }
    if(jobId && jobId!==""){
      const script = document.createElement('script');
      script.src = 'https://images.applygateway.com/chatjs/ApplyChatInclude.js?t=123';
      script.setAttribute('data-buyerid', buyerId);
      script.setAttribute('data-countrycode', countrycode);
      script.setAttribute('data-bottype', bottype);
      script.id = 'job-script';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      return () => {
        window?.voiceflow?.chat?.destroy();
        document.body.removeChild(script);
      };
  }
  }, [jobId,countrycode,jobExists]);

  useEffect(()=>{
    fetchJobs();
  },[])
  
	//Function to get job list
	const fetchJobs = async () => {
		setLoading(true);
		const jobs = await APIUtils.apiCall("GET", WebLinks.GetChatBotJobList + buyerID );
		if (jobs.isCatch) {
			message.error(constants.ERROR_MESSAGE);
		} else {
			if (jobs.resultObj?.statusCode === "2000") {
				setJobs(jobs.resultObj.data||[]);
			} else {
				setJobs([])
				message.success(jobs.resultObj?.message | constants.ERROR_MESSAGE)
			}
		}
		setLoading(false);
	};

  return (
    <Spin spinning={loading}>
    <div>
      <Row style={{ height: '100%' }}>
        <Col span={12} >
          {!loading?
          <>
          {jobExists===true?
          <div>
          <p className='font-bold text-xs'>
            This ChatBot can easily be placed on any job page of your Carrers Site and will allow candidates to easily apply for jobs including answering screening questions.
          </p>
          <br/>
          <p className='font-bold text-xs'>
            These applications will be tracked in Hire Intelligence
          </p>
          <br/>
          </div>:
          <div>
          <p className='font-bold text-xs'>
            Chat Bot has not been added in as a supplier on this account. Contact your CS rep to add it in.
          </p>
          <br/>
          <p className='font-bold text-xs'>
            These test jobs are loaded from another account.          
          </p>
          <br/>
          </div>}
          </>:null}
					<p>Select a job to Apply:</p>
					<Select
						className='w-full'
            placeholder="Select a job"
            onChange={(e)=>setJobId(e)}
					>
            {jobs.map((item) => (
                  <Option key={item.jobId} value={item.jobId}>{item.jobTitle}</Option>
            ))}
          </Select>
        </Col>

        <Col span={12} style={{ backgroundColor: '#fff' }}>
          {/* You can add content here later */}
        </Col>
      </Row>
    </div>
    </Spin>
  );
};

export default ChatBotJob;